export enum CHECK_RESPONSE {
	YES = 'YES',
	NO = 'NO',
}

export enum SORT_DIR {
	ASC = 'asc',
	DSC = 'dsc',
}
